export default __webpack_public_path__ + "static/media/OpenSans-Regular-webfont.967e123a.woff2";